<template>
    <div>
        <Strong
            class="text-primary cursor-pointer"
            @click="backToClientDetails"
        >
            Back to Details
        </Strong>

        <h3 style="margin-top: 20px;">Change Log of Client's Details</h3>

        <loader v-if="isLoading" />

        <b-col v-else sm="8">
            <b-table-simple
                borderless
                class="custom-table"
                style="margin-top: 20px;"
            >
                <b-tbody>
                    <template v-if="!data || data.length === 0">
                        <b-tr>
                            <b-td colspan="8">
                                <i>No logs available</i>
                            </b-td>
                        </b-tr>
                    </template>

                    <template v-else>
                        <b-tr v-for="log in data" :key="log.id">
                            <template
                                v-if="
                                    log.value_from === null ||
                                    log.value_from === undefined ||
                                    log.value_from === ''
                                "
                            >
                                <b-td>
                                    {{
                                        _setDateTimeDisplay(log.create_at.date)
                                    }}
                                    - Edited By {{ log.create_by.label }}
                                </b-td>
                                <b-td
                                    >Set
                                    {{ _sanitizeAndTitleCaseString(log.field) }}
                                    to <strong>{{ log.value_to }}</strong></b-td
                                >
                            </template>
                            <template
                                v-else-if="
                                    log.value_to === null ||
                                    log.value_to === undefined ||
                                    log.value_to === ''
                                "
                            >
                                <b-td>
                                    {{
                                        _setDateTimeDisplay(log.create_at.date)
                                    }}
                                    - Edited By {{ log.create_by.label }}
                                </b-td>
                                <b-td
                                    >Removed
                                    {{ _sanitizeAndTitleCaseString(log.field) }}
                                </b-td>
                            </template>
                            <template v-else>
                                <b-td>
                                    {{
                                        _setDateTimeDisplay(log.create_at.date)
                                    }}
                                    - Edited By {{ log.create_by.label }}
                                </b-td>
                                <b-td
                                    >{{
                                        _sanitizeAndTitleCaseString(log.field)
                                    }}
                                    changed from
                                    <strong>{{ log.value_from }}</strong> to
                                    <strong>{{ log.value_to }}</strong></b-td
                                >
                            </template>
                        </b-tr>
                    </template>
                </b-tbody>
            </b-table-simple>
        </b-col>
        <b-pagination
            v-if="meta"
            v-show="meta.lastPage > 1"
            class="vet-pagination"
            align="right"
            v-model="meta.currentPage"
            :total-rows="meta.total"
            :per-page="meta.perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="getHistoryLogs"
        />
    </div>
</template>
<script>
import Client from "@/services/client";
import Loader from "@/components/elements/loader-list";
export default {
    components: {
        Loader
    },
    emits: ["view-change-log"],
    data() {
        return {
            isLoading: false,
            data: null,
            meta: null
        };
    },
    mounted() {
        this.getHistoryLogs();
    },
    computed: {
        clientDetails() {
            return this.$store.getters["client/clientDetails"];
        }
    },
    methods: {
        backToClientDetails() {
            this.$emit("view-change-log", false);
        },
        getHistoryLogs(page) {
            this.isLoading = true;

            var self = this;
            var clientId = self.clientDetails.id;

            Client.getClientHistoryLogs(clientId, page ? page : 1)
                .then(response => {
                    var resource = response.response;
                    self.data = resource.resource;
                    self.meta = resource.meta;

                    this.isLoading = false;
                })
                .catch(error => {
                    error.data;
                    this.isLoading = false;
                });
        }
    }
};
</script>
<style type="text/css" lang="scss" scoped>
.button {
    color: #7a0000;
    text-decoration: none;
    background-color: transparent;
}
.custom-table td {
    padding: 0px;
    line-height: 35px;
}
</style>
